import React from "react";
import { Helmet } from "react-helmet";
import useSequentialScripts from "../../hooks/useSequentialScripts";
import Intro from "../../global/landing-pages/Intro";
import Video from "../../global/landing-pages/Video";
import ReadMore from "../../global/landing-pages/ReadMore";
import Journey from "../../global/landing-pages/Journey";

function TheVine() {
  useSequentialScripts([
    "/js/jquery.min.js",
    "/js/jquery.viewportchecker.min.js",
    "/js/main.js",
  ]);

  return (
    <>
      <Helmet>
        <title>I Am the Vine | Who Am I?</title>
      </Helmet>
      {/* Section Start - Introduction */}
      <Intro page="theVine" />
      {/* Section End - Introduction */}

      {/* SECTION BEGIN - VIDEO */}
      <Video page="theVine" triangle={true} quote="pullVerse" />
      {/* Section End - Video */}

      {/* Section Start - Read More*/}
      <ReadMore page="theVine" triangle={true} side="right" />
      {/* End section Read More */}

      {/* BEGIN SECTION Journey*/}
      <Journey />
      {/* END SECTION Journey */}
    </>
  );
}

export default TheVine;
